module.exports = __webpack_public_path__ + "static/media/tg9.e2dc00b4.jpg";